
const state = {
    struct: [] 
}

const getters = {
    structCovidParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            // Name_module: 'WEB_division',
            Name_module: 'Covid',
            Name_event: 'GET:this_struct'
        }))
    },
}


const mutations = {
    STRUCT(state, payload) {
        state.struct = payload.body;
    }
    
}

const actions = {
    

    getCovidStruct: async({commit, state, getters}) => {
        try {
            let structCovidParams = getters.structCovidParams;
            let structResponse = await fetch(`https://host1.medsafe.tech:50443/api/test?json=${structCovidParams}`);
            if (structResponse.status >= 200 && structResponse.status < 300) {
                commit('STRUCT', await structResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/structs.js